import React, { Component, Fragment } from "react";
import CompletedEvents from "./CompletedEvents";
import UpcomingEvents from "./UpcomingEvents";
import LatestEvent from "./LatestEvent";
import UpcomingEventBanner from "./UpcomingEventBanner";
import { Event } from ".";
import { PageConfigurationContextConsumer, Filters } from ".";
import ajax from "superagent";
import _ from "lodash";
import UpdateEventCoverPopup from "./UpdateEventCoverPopup";
import NoEventsView from "./NoEventsView";
const clearBtn = require("./images/clear-btn.svg");
const geoLoader = require("./../../assets/gss-loader.gif");

interface EventsContainerProps {
  eventsURL: string;
  completedEventsAvailable: boolean;
  upcomingEventsCount: Number;
  bulkRegisterCustomerLeadAPI: string;
  showGetNotifiedPopup: Function;
  eventPath: Function;
  editMode: boolean;
  showUpcomingEvents: () => void;
  upcomingEventsView: boolean;
  showCompletedEvents: () => void;
  keywordFilters: {
    eventName: string;
    location: string;
  };
  secureAccessToken: string | null;
  clearAllSearchFilters: () => void;
  updateEventCoverAPI: string;
  eventsAvailable: boolean;
  organizationName: string;
  organizationId: number;
  selfieSearchS3Bucket: string;
}

interface EventsContainerState {
  loadingEvents: boolean;
  completedEvents: Event[];
  upcomingEvents: Event[];
  filteredEvents: Event[];
  nextPage: Number;
  resetEvents: boolean;
  totalCount: Number;
  addObserver: boolean;
  updateCoverForEvent: Event | null;
}

class EventsContainer extends Component<
  EventsContainerProps,
  EventsContainerState
> {
  private eventTopRef: React.RefObject<HTMLInputElement>;
  endMarkerEl: HTMLDivElement | null;
  observer: any;

  constructor(props: EventsContainerProps) {
    super(props);
    this.state = {
      loadingEvents: true,
      completedEvents: [],
      upcomingEvents: [],
      filteredEvents: [],
      nextPage: 1,
      totalCount: 0,
      addObserver: true,
      updateCoverForEvent: null,
      resetEvents: true
    };
    this.eventTopRef = React.createRef();
  }

  componentDidMount(): void {
    if (this.props.eventsAvailable) {
      if (this.hasFilters(this.props.keywordFilters))
        this.loadEvents("", this.props.keywordFilters, true);
      else
        this.fetchEvents(
          this.props.upcomingEventsView,
          this.props.keywordFilters
        );
    }
  }

  componentWillReceiveProps(nextProps: Readonly<EventsContainerProps>): void {
    if (nextProps.eventsAvailable) {
      if (!_.isEqual(this.props.keywordFilters, nextProps.keywordFilters)) {
        if (this.hasFilters(nextProps.keywordFilters))
          this.loadEvents("", nextProps.keywordFilters, true);
        else
          this.fetchEvents(
            nextProps.upcomingEventsView,
            nextProps.keywordFilters
          );
      }
      if (
        !_.isEqual(this.props.upcomingEventsView, nextProps.upcomingEventsView)
      ) {
        this.fetchEvents(
          nextProps.upcomingEventsView,
          nextProps.keywordFilters
        );
      }
    }
  }

  public componentWillUnmount(): void {
    if (this.observer) this.observer.disconnect();
  }

  fetchEvents(
    upcomingEventsView: boolean,
    filters: { eventName: string; location: string }
  ) {
    if (upcomingEventsView || !this.props.completedEventsAvailable)
      this.loadEvents("upcoming", filters, true);
    else this.loadEvents("completed", filters, true);
  }

  eventsRequest = (
    url: string,
    type: string,
    filters: { eventName: string; location: string },
    page: Number
  ) => {
    let req = ajax.get(url).query({
      page: page
    });

    if (type) {
      req = req.query({
        type: type
      });
    }

    if (filters.eventName) {
      req = req.query({
        event_name: filters.eventName
      });
    }

    if (filters.location) {
      req = req.query({
        location: filters.location
      });
    }

    if (this.props.secureAccessToken) {
      req = req.query({
        secure_access_token: this.props.secureAccessToken
      });
    }

    return req;
  };

  loadEvents = (
    type: string,
    filters: { eventName: string; location: string },
    reset = false,
    callback = null
  ) => {
    if (reset)
      this.setState({
        loadingEvents: true,
        resetEvents: true
      });

    return this.eventsRequest(
      this.props.eventsURL,
      type,
      filters,
      reset ? 1 : this.state.nextPage
    )
      .then(response => {
        if (
          response.body.meta.nextPage !== this.state.nextPage ||
          (this.hasFilters(filters) && this.canUpdateEventsState(response)) ||
          (!this.hasFilters(filters) && this.canUpdateEventsState(response))
        ) {
          if (this.hasFilters(filters)) {
            this.setFilteredEvents(response, reset);
          } else {
            if (type === "upcoming") {
              this.setState({
                filteredEvents: [],
                upcomingEvents: response.body.events,
                loadingEvents: false,
                resetEvents: false
              });
            } else {
              this.setState(
                {
                  filteredEvents: [],
                  completedEvents: _.concat(
                    reset ? [] : this.state.completedEvents,
                    response.body.events
                  ),
                  addObserver: reset && response.body.events.length > 0,
                  nextPage: response.body.meta.nextPage,
                  totalCount: response.body.meta.totalCount,
                  loadingEvents: false,
                  resetEvents: false
                },
                () => {
                  if (this.state.addObserver) {
                    this.expandView();
                    this.setState({ addObserver: false });
                  }
                }
              );
            }
          }
        }
      })
      .catch(() => this.setState({ loadingEvents: true }));
  };

  private setFilteredEvents(response: any, reset: boolean) {
    let shouldDisconnectObserver = !_.isEqual(
      this.state.nextPage,
      response.body.meta.nextPage
    );
    this.setState(
      {
        filteredEvents: _.concat(
          reset ? [] : this.state.filteredEvents,
          response.body.events
        ),
        addObserver: reset && response.body.events.length > 0,
        nextPage: response.body.meta.nextPage,
        totalCount: response.body.meta.totalCount,
        loadingEvents: false,
        resetEvents: false
      },
      () => {
        if (this.state.addObserver) {
          if ((shouldDisconnectObserver || reset) && !!this.observer)
            this.observer.disconnect();
          this.expandView();
          this.setState({ addObserver: false });
        }
      }
    );
  }

  private hasFilters = (filters: { eventName: string; location: string }) =>
    !_.isEmpty(filters.eventName) || !_.isEmpty(filters.location);

  private hasMoreEvents = () => this.state.nextPage != null;

  private canUpdateEventsState = (response: any) =>
    response.body.meta.nextPage === 2 || response.body.meta.nextPage == null;

  footer = () => {
    if (!this.hasMoreEvents()) return null;

    return (
      <div
        className={`expanded
         ${this.state.loadingEvents ? "loading" : ""}`}
        style={{ border: "none" }}
      >
        {this.state.loadingEvents && this.loader()}
      </div>
    );
  };

  private expandView = () => {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (
            entry.intersectionRatio != 0 &&
            this.hasMoreEvents() &&
            !this.state.loadingEvents &&
            this.props.eventsAvailable
          ) {
            if (this.hasFilters(this.props.keywordFilters))
              this.loadEvents("", this.props.keywordFilters);
            else this.loadEvents("completed", this.props.keywordFilters);
            this.setState({ loadingEvents: true });
          }
        });
      },
      { rootMargin: "400px 0px 0px 0px" }
    );
    setTimeout(() => this.observer.observe(this.endMarkerEl), 500);
  };

  eventsContainer = (events: Event[]) => {
    return (
      <div className="dv-events-container" ref={this.eventTopRef}>
        <CompletedEvents
          events={events}
          showGetNotifiedPopup={this.props.showGetNotifiedPopup}
          editMode={this.props.editMode}
          eventPath={this.props.eventPath}
          showUpdateEventCoverPopup={this.showUpdateEventCoverPopup}
        />
        <div
          className="events-end-marker"
          ref={el => {
            this.endMarkerEl = el;
          }}
        ></div>
        {this.footer()}
      </div>
    );
  };

  showUpdateEventCoverPopup = (event: Event) => {
    this.setState({ updateCoverForEvent: event });
  };

  eventCoverPopupContainer = () => {
    if (this.state.updateCoverForEvent) {
      return (
        <UpdateEventCoverPopup
          closePopup={() => this.setState({ updateCoverForEvent: null })}
          event={this.state.updateCoverForEvent}
          updateEventCover={this.updateEventCover}
        />
      );
    } else return null;
  };

  public updateEventCover = (eventId: number, coverPhotoUrl: string) => {
    ajax
      .post(this.props.updateEventCoverAPI)
      .send({
        event_id: eventId,
        cover_photo_url: coverPhotoUrl
      })
      .then((res: any) => {
        let filtersApplied = this.hasFilters(this.props.keywordFilters);
        let events = filtersApplied
          ? this.state.filteredEvents
          : this.state.completedEvents;

        let index = _.findIndex(events, event => event.id === eventId);
        events[index] = res.body.event;

        if (filtersApplied) this.setState({ filteredEvents: events });
        else this.setState({ completedEvents: events });
        // @ts-ignore
        toastr.success("Cover photo updated successfully", null, {
          timeOut: 1000
        });
      })
      .catch(e => {
        // @ts-ignore
        toastr.error(
          "Error updating cover photo. Please try again later.",
          null,
          {
            timeOut: 3000
          }
        );
      });
  };

  public loader = () => {
    return (
      <div className="egm-loader gss-loader loading" style={{ clear: "both" }}>
        <img src={geoLoader} />
      </div>
    );
  };

  public render() {
    if (!this.props.eventsAvailable)
      return (
        <NoEventsView
          editMode={this.props.editMode}
          organizationName={this.props.organizationName}
        />
      );
    else if (this.state.loadingEvents && this.state.resetEvents) {
      return this.loader();
    } else if (
      (!this.props.completedEventsAvailable || this.props.upcomingEventsView) &&
      !this.hasFilters(this.props.keywordFilters)
    ) {
      return (
        <UpcomingEvents
          events={this.state.upcomingEvents}
          showCompletedEvents={this.props.showCompletedEvents}
          hasCompletedEvents={this.props.completedEventsAvailable}
          bulkRegisterCustomerLeadAPI={this.props.bulkRegisterCustomerLeadAPI}
        />
      );
    } else if (this.hasFilters(this.props.keywordFilters)) {
      return (
        <PageConfigurationContextConsumer>
          {pageConfiguration =>
            pageConfiguration && (
              <Fragment>
                {this.state.filteredEvents.length > 0 ? (
                  <div className="container">
                    <b>Search results</b>
                  </div>
                ) : (
                  <div className="container result-container">
                    <b>No search result found </b>
                    <div
                      className="clr-srch-btn"
                      onClick={() => this.props.clearAllSearchFilters()}
                    >
                      <img src={clearBtn} />
                      CLEAR SEARCH
                    </div>
                  </div>
                )}
                {this.eventsContainer(this.state.filteredEvents)}
                {this.eventCoverPopupContainer()}
              </Fragment>
            )
          }
        </PageConfigurationContextConsumer>
      );
    } else
      return (
        <PageConfigurationContextConsumer>
          {pageConfiguration =>
            pageConfiguration && (
              <Fragment>
                <LatestEvent
                  event={this.state.completedEvents[0]}
                  showGetNotifiedPopup={this.props.showGetNotifiedPopup}
                  eventPath={this.props.eventPath}
                  editMode={this.props.editMode}
                  showUpdateEventCoverPopup={this.showUpdateEventCoverPopup}
                />
                {this.props.upcomingEventsCount > 0 && (
                  <UpcomingEventBanner
                    upcomingEventsView={this.props.showUpcomingEvents}
                    eventsCount={this.props.upcomingEventsCount}
                  />
                )}
                {this.eventsContainer(
                  this.state.completedEvents.slice(
                    1,
                    this.state.completedEvents.length
                  )
                )}
                {this.eventCoverPopupContainer()}
              </Fragment>
            )
          }
        </PageConfigurationContextConsumer>
      );
  }
}

export default EventsContainer;
